import Vue from 'vue';
import VueRouter from 'vue-router';
import VueMeta from 'vue-meta';
import NotFound from '@/views/public/error/NotFound.vue';
import { TOKEN } from '@/services/util/makeToken';
import sessionToken from '@/services/util/sessionStorage';
// Rotas
import listRoutes from './routes';
import loginRoutes from './login';

const routes = [].concat(
  listRoutes,
  loginRoutes,
);

routes.push({
  // 404 Not Found page
  path: '*',
  component: NotFound,
  meta: {
    auth: false,
  },
});

Vue.use(VueRouter);
Vue.use(VueMeta);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

// Guards
const isAuthCheck = () => {
  const token = sessionToken.getObject(TOKEN);
  return token !== null && token !== undefined;
};

const isAuthView = (to) => !!(to.meta.auth === undefined || to.meta.auth);

const routeLogin = 'app.login';
const routeDashboard = 'app.dashboard';

const redirectRoute = (redirect) => {
  router.push({ name: redirect });
};

router.beforeEach((to, from, next) => {
  if (isAuthView(to) && !isAuthCheck()) {
    redirectRoute(routeLogin);
  } else if (to.name === routeLogin && isAuthCheck()) {
    redirectRoute(routeDashboard);
  }
  next();
});
// End Guards

export default router;
